module.exports = __webpack_public_path__ + "static/assets/efca1b18916c62c03bfbbf5093e9e15b.svg";